import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [cats, setCats] = useState([]);
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <Ctx.Provider value={{ user, setUser, refresh, logout, cats, settings }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
export const catName = (cats, slug) => cats.find((c) => c.slug === slug)?.name || slug;
